import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { GetDate, Number, OpenBase64Pdf, ReverseFormatDate, formatDate, setFocus, setTitle } from "../Common/Common";
import { AlertBox, AutoCompleteBox, DateBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';


const EmptyCollection = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode');
    const IsBackOfficeUser = cookies.get('IsBackOfficeUser');

    const [SalesPerson, setSalesPerson] = useState([]);
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [CustomerData, setCustomerData] = useState([]);
    const [MenuText, setMenuText] = useState("Empty Collection / Invoice");
    const [isShowSaveButton, setIsShowSaveButton] = useState(false);
    const [isShowSearchButton, setIsShowSearchButton] = useState(true);

    const [GrandTotalAmount, setGrandTotalAmount] = useState(0.00);

    const [isLoading, setIsLoading] = useState(false);

    const [Print, setPrint] = useState({
        InvoiceNo: '',
        IsInvoicePrint: false,

    });

    const [SaveData, setSaveData] = useState({
        InvoiceDate: GetDate(0),
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        Customer: "",
        CashAmount: "0.00",
        MobileMoney: "0.00",
        ChequeAmount: "0.00",
        ChequeNo: "",
        ChequeDate: "",
        ItemDetails: [],
        EmptiesDetails: [],
    });

    const HandleChange = (prop, value) => {
        setSaveData(SaveData => ({ ...SaveData, [prop]: value }));
    }


    const handleGetEmptiesData = (Customer, SalesPerson) => {
        setSaveData(prevSaveData => ({
            ...prevSaveData,
            Customer: Customer,
            EmptiesDetails: []
        }));
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token: Token,
            LoginUserCode: loginCodeString,
            Customer: Customer,
            SalesPerson: SalesPerson === undefined ? SaveData.SalesPerson : SalesPerson
        }

        post(`${API_SERVER}/api/Operation/GetEmptyCollection`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                let emptiesDetails = [];
                res.Data.forEach((item, index) => {
                    let Item = {};
                    Item.Item = item.Item;
                    Item.ItemPrice = item.ItemPrice;
                    Item.Quantity = item.Quantity;
                    Item.ReturnQuantity = item.ReturnQuantity;
                    Item.InvoiceQuantity = item.InvoiceQuantity;
                    Item.TotalAmount = item.TotalAmount;
                    emptiesDetails.push(Item);
                });
                setSaveData(prevSaveData => ({
                    ...prevSaveData,
                    Customer: Customer,
                    EmptiesDetails: emptiesDetails,
                    CashAmount: "0.00",
                    MobileMoney: "0.00",
                    ChequeAmount: "0.00",
                    ChequeNo: "",
                    ChequeDate: "",
                }));
                setIsShowSaveButton(true)
                setIsShowSearchButton(false)
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, "");
            }
            if (res.Status === "ERROR") {
                Swal.fire({
                    text: res.Message,
                    icon: res.Status?.toLowerCase(),
                    title: res.Status?.toUpperCase(),
                    confirmButtonColor: '#238914',
                    allowOutsideClick: false,
                    width: 500,
                    didClose: () => {
                        if (res.Focus !== "")
                            document.getElementById(res.Focus)?.focus();
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
                setIsShowSaveButton(false)
                setIsShowSearchButton(true)
            }
            setIsLoading(false);
            setGrandTotalAmount(0.00)
        })
    };


    const handleOnChangeEmptiesReturnQuantity = (e, rowIndex, type) => {
        const inputValue = e.target.value.replace(/[^\d\-.]/g, '');
        const enteredQty = parseInt(inputValue) || 0;

        const newEmptiesDetails = [...SaveData.EmptiesDetails];
    //    const availableQty = parseInt(newEmptiesDetails[rowIndex]?.Quantity) || 0;

        const itemPrice = parseFloat(newEmptiesDetails[rowIndex]?.ItemPrice) || 0;
        const updatedTotalAmount = itemPrice * enteredQty;

        const updatedDetails = newEmptiesDetails.map((item, i) => {
            if (i === rowIndex) {
                return {
                    ...item,
                    ReturnQuantity: inputValue,
                    TotalAmount: updatedTotalAmount.toFixed(2)
                };
            }

            // Update previous row (if exists) based on `type`
            if (i === rowIndex - 1 && type) {
                const multiplier = type.includes("24") ? 24 : 12;
                return {
                    ...item,
                    ReturnQuantity: (enteredQty * multiplier).toString()
                };
            }

            return item;
        });

        const emptyCrateDetails = updatedDetails.filter(item =>
            item.Item?.split(" ")[0]?.toLowerCase().includes("crate")
        );

        const totalAvailableQty = emptyCrateDetails.reduce((sum, item) => {
            const qty = parseFloat(item.Quantity);
            return sum + (isNaN(qty) ? 0 : qty);
        }, 0);

        const totalReturnQty = emptyCrateDetails.reduce((sum, item) => {
            const qty = parseFloat(item.ReturnQuantity);
            return sum + (isNaN(qty) ? 0 : qty);
        }, 0);


        //if (totalReturnQty > totalAvailableQty) {
        //    AlertBox("error", "You can't return more than the sum of the EmptyCrate Quantity .", "");
        //    return;
        //}

        setSaveData(prev => ({
            ...prev,
            EmptiesDetails: updatedDetails
        }));

        const grandTotal = updatedDetails.reduce((acc, item) => {
            const amt = parseFloat(item.TotalAmount) || 0;
            return acc + amt;
        }, 0);

        setGrandTotalAmount(parseFloat(grandTotal.toFixed(2)));
    };


    const handleOnChangeEmptiesInvoiceQuantity = (e, rowIndex) => {
        let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
        setSaveData(prevSaveData => ({
            ...prevSaveData,
            EmptiesDetails: prevSaveData.EmptiesDetails.map((item, i) => {
                if (i === rowIndex) {
                    let totalAmount = (+Number(inputValue) * item.ItemPrice);
                    return { ...item, InvoiceQuantity: inputValue, TotalAmount: totalAmount };
                }
                return item;
            })
        }));
    };

    const handleClearData = () => {
        setSaveData({
            ...SaveData,
            InvoiceDate: GetDate(0),
            SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
            Customer: "",
            CashAmount: "0.00",
            MobileMoney: "0.00",
            ChequeAmount: "0.00",
            ChequeNo: "",
            ChequeDate: "",
            ItemDetails: [],
            EmptiesDetails: [],
        });
        setFocus('txtSalesPerson')
        setIsShowSaveButton(false)
        setIsShowSearchButton(true)
    }

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: SalesPersonPre.split(':')[0].trim(),
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }

    let SalesPersonArr = []
    for (let i = 0; i < SalesPerson.length; i++) {
        let mydata = SalesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    let CustomerArr = []
    for (let i = 0; i < CustomerData.length; i++) {
        let mydata = CustomerData[i]?.values
        CustomerArr.push(mydata)
    };

    const handleSaveData = async (Item, BodyIndex) => {
        const grandTotalAmount = String(GrandTotalAmount)
        var msg = "";
        if (grandTotalAmount === '0') {
            msg = "Are you sure you want to received empty items ?";
        }
        else {
            msg = "Do you want to collect Empty ?";
        }
        Swal.fire({
            title: msg,
            showDenyButton: true,
            showCancelButton: false,
            icon: "info",
            confirmButtonText: "Yes",
            denyButtonText: "No"
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                const loginCodeString = String(LoginUserCode);
                const data = {
                    ...SaveData,
                    Token,
                    LoginUserCode: loginCodeString,
                    Source: 'WEB',
                    Type: 'EMPTYCOLLECTION'
                };
                post(`${API_SERVER}/api/Operation/InsertEmptyCollection`, data, (res) => {
                    setIsLoading(false);
                    if (res.status === 'SUCCESS') {
                        if (res.message !== "") {
                            AlertBox(res.status, res.message, res.focus);
                        }
                        if (res.isInvoicePrint) {
                            setPrint({
                                InvoiceNo: res.invoiceNo,
                                IsInvoicePrint: res.isInvoicePrint,
                            });
                            OpenBase64Pdf(res.base64PDF, 'CustomerEmptyCollectionInvoicePrint_' + res.invoiceNo, '_blank');
                        }
                        handleClearData();
                    } else if (res.message === "EXPIRED") {
                        navigate('/Login')
                    } else if (res.message !== "") {
                        AlertBox(res.status, res.message, res.focus);
                    }
                    setIsLoading(false);
                });
            }
        });
    };



    useEffect(() => {
        setFocus('txtCustomer');
        setTitle('EmptyCollection', setOpen);
        setSalesPersonPre(SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>

                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtInvoiceFromDate") };
                                                }}
                                                label='Customer '
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={SaveData.Customer ? SaveData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <DateBox
                                                id='txtInvoiceFromDate'
                                                inputrefs={inputrefs}
                                                disabled={IsBackOfficeUser === "NO"}
                                                label='Invoice Date'
                                                placeholder="Invoice Date"
                                                required={false}
                                                selected={SaveData.InvoiceDate === '' ? '' : new Date(SaveData.InvoiceDate)}
                                                onChange={(e) => {
                                                    let dateArr = e?.toString()?.split(' ')
                                                    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`
                                                    setSaveData({ ...SaveData, InvoiceDate: dateArr })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtItemNo") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={SaveData.SalesPerson ? SaveData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)
                                                    //    handleGetEmptiesData(SaveData.Customer, newInputValue);

                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-1">
                                        <div className="row">
                                            {
                                                SaveData.EmptiesDetails.length > 0 ? (
                                                    <>
                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                            <div className="heading-box">
                                                                <div className="heading d-flex gap-4">
                                                                    <h6 className="m-0 font-weight-bold text-primary" >Empties Item Details</h6>
                                                                </div>
                                                            </div>

                                                            <div className="op-invoice recoard-bata service-content-area">
                                                                <div className="table-responsive">
                                                                    <table className="table-bordered" width="100%" cellSpacing="0">
                                                                        <thead className="sticky-top">
                                                                            <tr>
                                                                                <th>Item No</th>
                                                                                <th style={{ textAlign: 'right' }}>Item Price</th>
                                                                                <th style={{ textAlign: 'right' }}>Quantity</th>
                                                                                <th style={{ textAlign: 'right' }}>Return Quantity<span className="Required">*</span></th>
                                                                                {/*<th style={{ textAlign: 'right' }}>Invoice Quantity<span className="Required">*</span></th>*/}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {SaveData.EmptiesDetails?.map((item, bodyIndex) => (

                                                                                <tr key={bodyIndex}>

                                                                                    <td className='fields'>
                                                                                        {item.Item}
                                                                                    </td>
                                                                                    <td className='fields' style={{ textAlign: 'right' }}>
                                                                                        {item.ItemPrice}
                                                                                    </td>
                                                                                    <td className='fields' style={{ textAlign: 'right' }}>
                                                                                        {item.Quantity}
                                                                                    </td>

                                                                                    <td className="fields">
                                                                                        <input
                                                                                            className="form-control"
                                                                                            style={{ textAlign: 'right' }}
                                                                                            type="text"
                                                                                            id={`txtReturnQuantity${bodyIndex + 1}`}
                                                                                            maxLength="10"
                                                                                            value={item.ReturnQuantity}
                                                                                            onChange={(e) => handleOnChangeEmptiesReturnQuantity(e, bodyIndex, item?.Item?.split(" ")[0])}
                                                                                            onFocus={(e) => e.target.select()}
                                                                                            disabled={item?.Item?.toLowerCase()?.includes("bottle")}
                                                                                        />
                                                                                    </td>
                                                                                    {/*<td className='fields'>*/}
                                                                                    {/*    <input*/}
                                                                                    {/*        className="form-control"*/}
                                                                                    {/*        style={{ textAlign: 'right' }}*/}
                                                                                    {/*        type='text'*/}
                                                                                    {/*        id={`txtEnvoiceEmpties${bodyIndex + 1}`}*/}
                                                                                    {/*        maxLength="10"*/}
                                                                                    {/*        value={item.InvoiceQuantity}*/}
                                                                                    {/*        onChange={(e) => { handleOnChangeEmptiesInvoiceQuantity(e, bodyIndex) }}*/}
                                                                                    {/*        onFocus={(e) => { e.target.select(); }}*/}
                                                                                    {/*    />*/}
                                                                                    {/*</td>*/}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                        <tfoot>
                                                                            <tr>
                                                                                <td colSpan="3" style={{ textAlign: 'right' }}><b>Total</b></td>
                                                                                <td style={{ textAlign: 'right' }}><b>{GrandTotalAmount}</b></td>
                                                                            </tr>
                                                                        </tfoot>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/*    <div className="col-lg-4 col-md-4 col-sm-12" style={{ float: 'right' }} >
                                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                                <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginTop: "3px", marginLeft: "211%", border: "1px solid black", borderRadius: "5px" }}>
                                                                    <div className="heading-box" style={{ backgroundColor: "green" }}>
                                                                        <div className="heading d-flex gap-4">
                                                                            <h6 className="m-0 font-weight-bold text-primary" >Payment Collection</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-box service-content-area" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                                                        <div className="row align-items-end">
                                                                            <div className="col-lg-6 col-md-6 col-sm-6">
                                                                                <div className="fields">
                                                                                    <label className="form-label">Cash Amount</label>
                                                                                    <input
                                                                                        id='txtCashAmount'
                                                                                        type="text"
                                                                                        style={{ textAlign: 'right' }}
                                                                                        maxLength="10"
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                setFocus('txtMobileMoney')
                                                                                            };
                                                                                        }}
                                                                                        className="form-control"
                                                                                        placeholder="Cash Amount"
                                                                                        value={SaveData.CashAmount}
                                                                                        onChange={(e) => {
                                                                                            let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
                                                                                            let TotalReceipt = parseFloat(SaveData.MobileMoney) + parseFloat(SaveData.ChequeAmount) + parseFloat(inputValue);
                                                                                            if (TotalReceipt > GrandTotalAmount) {
                                                                                                AlertBox("error", "Received amount should not more than Total.", "txtCashAmount");
                                                                                                inputValue = 0.00;
                                                                                            }
                                                                                            HandleChange("CashAmount", inputValue);

                                                                                        }}
                                                                                        onFocus={(e) => { e.target.select(); }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6">
                                                                                <div className="fields">
                                                                                    <label className="form-label">Mobile Money</label>
                                                                                    <input
                                                                                        id='txtMobileMoney'
                                                                                        type="text"
                                                                                        style={{ textAlign: 'right' }}
                                                                                        maxLength="10"
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                setFocus('txtChequeAmount')
                                                                                            };
                                                                                        }}
                                                                                        className="form-control"
                                                                                        placeholder="Mobile Money"
                                                                                        value={SaveData.MobileMoney}
                                                                                        onChange={(e) => {
                                                                                            let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
                                                                                            let TotalReceipt = parseFloat(SaveData.CashAmount) + parseFloat(SaveData.ChequeAmount) + parseFloat(inputValue);
                                                                                            if (TotalReceipt > GrandTotalAmount) {
                                                                                                AlertBox("error", "Received amount should not more than Grand Total.", "txtMobileMoney");
                                                                                                inputValue = 0.00;
                                                                                            }
                                                                                            HandleChange("MobileMoney", inputValue);
                                                                                        }}
                                                                                        onFocus={(e) => { e.target.select(); }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6">
                                                                                <div className="fields">
                                                                                    <label className="form-label">Cheque Amount</label>
                                                                                    <input
                                                                                        id='txtChequeAmount'
                                                                                        type="text"
                                                                                        style={{ textAlign: 'right' }}
                                                                                        maxLength="10"
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                setFocus('txtChequeNo')
                                                                                            };
                                                                                        }}
                                                                                        className="form-control"
                                                                                        placeholder="Cheque Amount"
                                                                                        value={SaveData.ChequeAmount}
                                                                                        onChange={(e) => {
                                                                                            let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
                                                                                            let TotalReceipt = parseFloat(SaveData.CashAmount) + parseFloat(SaveData.MobileMoney) + parseFloat(inputValue);
                                                                                            if (TotalReceipt > GrandTotalAmount) {
                                                                                                AlertBox("error", "Received amount should not more than Grand Total.", "txtChequeAmount");
                                                                                                inputValue = 0.00;
                                                                                            }
                                                                                            HandleChange("ChequeAmount", inputValue, SaveData.ChequeDate = '', SaveData.ChequeNo = '');

                                                                                        }}
                                                                                        onFocus={(e) => { e.target.select(); }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            {parseFloat(SaveData.ChequeAmount) > 0 ?
                                                                                <>
                                                                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                                                                        <div className="fields">
                                                                                            <label className="form-label">Cheque No</label>
                                                                                            <input
                                                                                                id='txtChequeNo'
                                                                                                type="text"
                                                                                                maxLength="20"
                                                                                                onKeyDown={(e) => {
                                                                                                    if (e.key === 'Enter') {
                                                                                                        setFocus('txtChequeDate')
                                                                                                    };
                                                                                                }}
                                                                                                className="form-control"
                                                                                                placeholder="Cheque No"
                                                                                                value={SaveData.ChequeNo}
                                                                                                onChange={(e) => {
                                                                                                    HandleChange("ChequeNo", e.target.value);
                                                                                                }}
                                                                                                onFocus={(e) => { e.target.select(); }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                                                                        <div className="fields">
                                                                                            <label className="form-label">Cheque Date</label>
                                                                                            <DatePicker
                                                                                                selected={ReverseFormatDate(SaveData.ChequeDate)}
                                                                                                id='txtChequeDate'
                                                                                                className="form-control"
                                                                                                placeholderText="Cheque Date"
                                                                                                dateFormat={'dd-MMM-yyyy'}
                                                                                                autoComplete='off'
                                                                                                onChange={(date) => {
                                                                                                    setSaveData({ ...SaveData, ChequeDate: formatDate(date) })
                                                                                                }}
                                                                                                onKeyDown={(e) => {
                                                                                                    if (e.key === 'Enter') {
                                                                                                        setFocus('txtChequeDate')
                                                                                                    };
                                                                                                }}
                                                                                                minDate={new Date()}
                                                                                            />

                                                                                        </div>
                                                                                    </div>
                                                                                </> : <></>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </>
                                                ) : (<div className="col-lg-8 col-md-8 col-sm-12"></div>)
                                            }
                                        </div>

                                    </div>
                                    {/* Item section End*/}
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {isShowSearchButton && <> <button className="button save-btn" id='btnSave' onClick={() => handleGetEmptiesData(SaveData.Customer, SaveData.SalesPerson)}>
                                                <i className="bi bi-search" />
                                                Search
                                            </button></>}
                                            {isShowSaveButton && <> < button className="button save-btn" id='btnSave' onClick={handleSaveData}>
                                                <i className="bi bi-check" />Save
                                            </button></>}
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main >
    )
}
export default EmptyCollection